export default __webpack_public_path__ + "static/media/react.9dbbabf1.svg";